/* Lumenary home chapters. Vanilla, no dependencies. Motion only when the visitor allows it.
   The exposure picker needs no script (radio inputs + CSS). */
(() => {
  if (window.__lvh) return; window.__lvh = true;
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) root.classList.add('lvh-motion');
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const ease = (t) => 1 - Math.pow(1 - t, 4);
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };

  /* reveal on enter */
  const items = $$('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) items.forEach((e) => e.classList.add('is-in'));
  else {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    items.forEach((e) => io.observe(e));
  }

  /* before / after */
  function compare(box) {
    const handle = $('[data-lvh-handle]', box);
    let p = +(box.dataset.start || 50);
    const set = (v) => { p = Math.max(0, Math.min(100, v)); box.style.setProperty('--p', p.toFixed(2)); if (handle) handle.setAttribute('aria-valuenow', Math.round(p)); };
    box.__set = set; set(p);
    const move = (e) => { const r = box.getBoundingClientRect(); set(((e.clientX - r.left) / r.width) * 100); };
    box.addEventListener('pointerdown', (e) => { if (e.button) return; box.setPointerCapture(e.pointerId); box.classList.add('is-drag'); if (box.__stop) box.__stop(); move(e); });
    box.addEventListener('pointermove', (e) => { if (box.classList.contains('is-drag')) move(e); });
    ['pointerup', 'pointercancel'].forEach((t) => box.addEventListener(t, () => box.classList.remove('is-drag')));
    if (handle) handle.addEventListener('keydown', (e) => {
      const k = { ArrowLeft: -2, ArrowRight: 2, Home: -100, End: 100 }[e.key];
      if (k !== undefined) { e.preventDefault(); if (box.__stop) box.__stop(); set(p + (e.shiftKey ? k * 5 : k)); }
    });
    return set;
  }
  $$('[data-lvh-compare]').forEach((box) => {
    const set = compare(box);
    if (box.dataset.lvhCompare !== 'hero') return;
    if (reduce || document.hidden) { set(50); box.classList.add('is-ready'); return; }
    set(100); box.classList.add('is-ready');
    let raf; const dur = 2200; let t0;
    const step = (ts) => { t0 = t0 || ts; const k = Math.min(1, (ts - t0) / dur); set(100 - 50 * ease(k)); if (k < 1) raf = requestAnimationFrame(step); };
    box.__stop = () => cancelAnimationFrame(raf);
    setTimeout(() => { raf = requestAnimationFrame(step); }, 600);
  });

  /* stock viewer. Only the picked scene is loaded. A film stock the visitor reaches for (hover, focus, touch) is warmed
     in advance, so the click feels instant without loading all scenes up front. */
  $$('[data-lvh-try]').forEach((box) => {
    let data; try { data = JSON.parse($('script[data-lvh-json]', box).textContent); } catch (e) { return; }
    const cmp = $('[data-lvh-compare]', box), imgB = $('[data-b]', cmp), imgA = $('[data-a]', cmp);
    const tag = $('[data-tag]', cmp), proto = $('[data-proto]', box), scenes = $('[data-scenes]', box);
    const btns = $$('[data-si]', box);
    const SIZES = '(min-width: 750px) 667px, calc(100vw - 40px)';
    let si = 0, token = 0;
    const warm = (u, set) => { const i = new Image(); i.sizes = SIZES; if (set) i.srcset = set; i.src = u; return i; };
    const decoded = (i) => (i.decode ? i.decode().catch(() => {}) : new Promise((r) => { i.onload = i.onerror = r; }));
    const show = (s, c, first) => {
      si = s; const st = data.stocks[s], sn = st.scenes[c]; if (!sn) return;
      const my = ++token;
      cmp.style.setProperty('--w', sn.w); cmp.style.setProperty('--h', sn.h);
      imgA.alt = `${st.name}, the same RAW file after`; tag.textContent = st.name;
      proto.textContent = `${st.name} · same RAW file, before and after`;
      btns.forEach((b, i) => { b.setAttribute('aria-selected', i === s ? 'true' : 'false'); b.tabIndex = i === s ? 0 : -1; });
      scenes.replaceChildren(...st.scenes.map((x, i) => {
        const b = el('button', 'lvh-try__scene'); b.type = 'button'; b.setAttribute('aria-pressed', i === c ? 'true' : 'false'); b.setAttribute('aria-label', `${st.name}, scene ${i + 1}`);
        const im = el('img'); im.src = x.t; im.alt = ''; im.loading = 'lazy'; b.append(im);
        b.addEventListener('click', () => { show(si, i); const n = $$('.lvh-try__scene', scenes)[i]; if (n) n.focus({ preventScroll: true }); }); return b;
      }));
      if (first) return; /* the first scene is already in the markup */
      /* keep the current photo (slightly dimmed) until the new pair is decoded, then swap both at once */
      cmp.classList.add('is-wait');
      const pb = warm(sn.b, sn.bset), pa = warm(sn.a, sn.aset);
      Promise.race([Promise.all([decoded(pb), decoded(pa)]), new Promise((r) => setTimeout(r, 2500))]).then(() => {
        if (my !== token) return;
        imgB.sizes = imgA.sizes = SIZES; imgB.srcset = sn.bset; imgA.srcset = sn.aset; imgB.src = sn.b; imgA.src = sn.a;
        if (cmp.__stop) cmp.__stop(); cmp.__set(50); cmp.classList.remove('is-wait');
      });
    };
    const reach = (i) => { const sn = data.stocks[i] && data.stocks[i].scenes[0]; if (!sn || i === si || sn.__warm) return; sn.__warm = [warm(sn.b, sn.bset), warm(sn.a, sn.aset)]; };
    btns.forEach((b, i) => {
      b.addEventListener('click', () => show(i, 0));
      ['pointerenter', 'focus', 'touchstart'].forEach((t) => b.addEventListener(t, () => reach(i), { passive: true }));
      b.addEventListener('keydown', (e) => {
        const d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key]; if (!d) return;
        e.preventDefault(); const n = (i + d + btns.length) % btns.length; show(n, 0); btns[n].focus();
      });
    });
    show(0, 0, true);
  });

  /* camera finder: type a model, or tap a brand chip to filter */
  $$('[data-lvh-cam]').forEach((box) => {
    const q = $('input', box), res = $('[data-res]', box), msg = $('[data-msg]', box), brands = $('[data-brands]', box);
    const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const MAX = 6; let brand = '', data = null, loading;
    const render = () => {
      if (!data) return;
      const t = norm(q.value); res.replaceChildren(); msg.textContent = '';
      if (t.length < 2 && !brand) return;
      const toks = t.length < 2 ? [] : t.split(' ');
      const hits = data.flat.filter((m) => (!brand || m.b === brand) && toks.every((k) => m.hay.includes(k)));
      if (!hits.length) { msg.textContent = brand ? `No ${brand} model matches that. The Standard version still works with your camera.` : 'No match. The Standard version still works with your camera.'; return; }
      hits.slice(0, MAX).forEach((m, i) => {
        const li = el('li'); li.style.setProperty('--i', i);
        const l = el('span'); l.append(el('strong', '', m.aka[0] || m.n));
        if (m.aka[0] && m.aka[0] !== m.n) { l.append(' ', el('small', '', m.n)); }
        li.append(l, el('span', 'lvh-cam__ok', 'Supported')); res.append(li);
      });
      if (hits.length > MAX) msg.textContent = `${hits.length - MAX} more ${brand ? brand + ' models' : 'matches'}. ${t.length < 2 ? 'Type your model' : 'Keep typing'} to narrow it down.`;
    };
    const load = () => loading || (loading = fetch(box.dataset.src).then((r) => r.json()).then((d) => {
      d.flat = d.brands.flatMap((b) => b.models.map((m) => ({ b: b.name, n: m.n, aka: (m.aka || []).filter((a) => !a.r).map((a) => a.n), hay: norm([m.n, ...(m.aka || []).map((a) => a.n), ...(m.x || [])].join(' ')) })));
      data = d;
      if (brands) brands.replaceChildren(...d.brands.filter((b) => b.models.length > 10).sort((a, b) => b.models.length - a.models.length).map((b) => {
        const li = el('li'), bt = el('button', 'lvh-cam__chip'); bt.type = 'button'; bt.setAttribute('aria-pressed', 'false');
        const short = b.name.split(' / ')[0]; bt.append(short, el('small', '', b.models.length)); bt.setAttribute('aria-label', `${b.name}, ${b.models.length} models`);
        bt.addEventListener('click', () => { brand = brand === b.name ? '' : b.name; $$('.lvh-cam__chip', brands).forEach((x) => x.setAttribute('aria-pressed', x === bt && brand ? 'true' : 'false')); render(); });
        li.append(bt); return li;
      }));
      return d;
    }).catch(() => null));
    q.addEventListener('focus', load, { once: true });
    q.addEventListener('input', async () => { await load(); render(); });
    if ('IntersectionObserver' in window) { const o = new IntersectionObserver((es) => { if (es[0].isIntersecting) { o.disconnect(); load(); } }, { rootMargin: '400px' }); o.observe(box); } else load();
  });

  /* review total, live from the public Klaviyo reviews endpoint (the same one the reviews widget reads) */
  $$('[data-lvh-agg]').forEach((box) => {
    if (!box.dataset.src) return;
    const num = $('[data-agg-num]', box), count = $('[data-agg-count]', box), stars = $('.lvh-stars', box), bars = $('[data-agg-bars]', box);
    /* one or more endpoints (space-separated): the review pool of all Analog Vision Studio products is summed */
    Promise.all(box.dataset.src.trim().split(/\s+/).map((u) => fetch(u).then((r) => r.json()).catch(() => null))).then((list) => {
      let n = 0, sum = 0; const h = [0, 0, 0, 0, 0];
      list.forEach((d) => { const p = (d && (d.summary || d.product)) || {}; const c = +p.review_count || 0, a = +p.star_rating || 0;
        if (!c || !a) return; n += c; sum += a * c; if (Array.isArray(p.rating_histogram) && p.rating_histogram.length === 5) p.rating_histogram.forEach((v, i) => { h[i] += +v || 0; }); });
      const avg = n ? sum / n : 0;
      if (!n || !avg) return;
      num.textContent = avg.toFixed(1); count.textContent = `${n} ${count.dataset.suffix || 'reviews'}`;
      if (stars) { stars.style.setProperty('--v', avg.toFixed(2)); stars.setAttribute('aria-label', `${avg.toFixed(1)} out of 5 stars`); }
      $$('[data-agg-count-inline]').forEach((e) => { e.textContent = n; });
      if (bars && Array.isArray(h) && h.length === 5) {
        bars.replaceChildren(...[5, 4, 3, 2, 1].filter((s) => h[s - 1] > 0).map((s) => {
          const pct = Math.round((h[s - 1] / n) * 100), li = el('li'); li.setAttribute('aria-label', `${s} stars: ${pct < 1 ? 'under 1' : pct} percent`);
          const tr = el('i'), fill = el('b'); fill.style.width = Math.max(1, (h[s - 1] / n) * 100) + '%'; tr.append(fill);
          li.append(el('span', '', `${s} ★`), tr, el('span', '', (pct < 1 ? '<1' : pct) + ' %')); return li;
        }));
      }
      box.hidden = false;
    }).catch(() => {});
  });

  /* review reel */
  $$('[data-lvh-reel]').forEach((box) => {
    const track = $('.lvh-reel__track', box), btn = $('.lvh-reel__pause', box);
    if (track && !reduce) { const dur = Math.max(40, Math.round(track.scrollWidth / 2 / 38)); box.style.setProperty('--lvh-reel-dur', dur + 's'); }
    if (btn) btn.addEventListener('click', () => { const p = box.classList.toggle('is-paused'); btn.textContent = p ? 'Play' : 'Pause'; btn.setAttribute('aria-pressed', p ? 'true' : 'false'); });
  });

  /* links to the free trial land on the form and put the cursor in the field */
  $$('a[href="#free"]').forEach((a) => a.addEventListener('click', (e) => {
    const t = document.getElementById('free'); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    const f = $('input[type="email"]', t); if (f) setTimeout(() => f.focus({ preventScroll: true }), reduce ? 0 : 500);
  }));
})();
